export default {
    data() {
        return {
            cargando: false,
            pacientes: [],
            pacientesSimilares: [],
        }
    },
    methods: {
        async _searchPac(data) {
            try {
                const { status, body } = await this.$http.post(
                    "pacientes/buscar",
                    { paciente: data },
                    this.$headers
                )
                if (status === 200 && 'pacientes' in body) {
                    this.pacientes = body.pacientes;
                    this.pacientesSimilares = [];
                } else {
                    this.$emit('msg', res.error);
                }
            } catch (err) {
                this.$emit('httpError', err)
            }
        }
    }
}